import React from 'react'
import Slider from 'react-slick'
import {Link} from 'react-router-dom'

class MajorPrizes extends React.Component {

  render() {
    const settings = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 100,
      slidesToScroll: 1,
      fade: false,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    }

    return (
      <div>
        <h2>Major Prizes</h2>

        <Slider className="prizes-slider" {...settings}>
          <div>
            <img src="/assets/netherworld.png" />
            <h3>Gold Prize</h3>
            <p>Netherworld will swing you a custom-built arcade cabinet designed by Lukas Kasper (@kaspersart) worth $1500, plus a $300 bar tab and $200 worth of game tokens to explore their otherworldly drink and arcade offerings.*</p>
          </div>
          <div>
            <img src="/assets/fly365.png" />
            <h3>Gold Prize</h3>
            <p>Fly365 are offering you two adult return flights to Bangkok, Thailand! These tickets are to be used within 12 months from date of issue outside black out periods school holidays/ peak periods IE: Xmas, Easter holidays. Please note these tickets are non-transferrable and the dates cannot be changed.*</p>
          </div>
          <div>
            <img src="/assets/triffid.png" />
            <h3>Gold Prize</h3>
            <p>The Triffid's Golden Ticket! Score yourself one adult annual double-pass to The Triffid, that's 12 months UNLIMITED free access to any gig at The Triffid for yourself and a friend.*</p>
          </div>
          <div>
            <img src="/assets/bluesfest.png" />
            <h3>Gold Prize</h3>
            <p>Byron Bay’s iconic Bluesfest is giving you the chance to win two 5-day adult tickets complete with camping space for their 30th anniversary event.*</p>
          </div>
          <div>
            <img src="/assets/junglelove.png" />
            <h3>Gold Prize</h3>
            <p>Jungle Love have four 3-day adult passes up for grabs including festival access, camping, and parking for one vehicle.*</p>
          </div>
          <div>
            <img src="/assets/woodford.png" />
            <h3>Gold Prize</h3>
            <p>Enter the wacky and wonderful world of Woodford Folk Festival with four season passes to the 2018 festival including two adult season passes and two youth season passes, plus camping!</p>
          </div>
          <div>
            <img src="/assets/supersub.png" />
            <h3>Super Sub Prize</h3>
            <p>One Golden Double Pass to both The Tivoli and The Zoo! That's right, one annual double pass for shows at The Zoo AND another annual double pass for shows at The Tivoli! One lucky Super Sub will enjoy unlimited shows across both venues for 12 months. This opportunity also provides the winner the option to be our Live Music correspondent for both venues over the year. Available for over-18s only.</p>
          </div>
          <div>
            <img src="/assets/household.png" />
            <h3>Household Prize</h3>
            <p>One winner takes all prize pack including a mosaic lamp from Thousand Island Dressing, landscaping from Leafcutters, two $50 Avid Reader vouchers, two standard adult double-passes to Dendy Portside and a double pass to their premium lounge, AND a 10 session pass to Free Space VR! (Please note that each VR session must involve two or more people).
            </p>
          </div>
          <div>
            <img src="/assets/bigsound.png" />
            <h3>Musican Prize</h3>
            <p>Three BIGSOUND Purple Passes thanks to QMusic! Any Band or Solo Artist who pays their subscription before August 30 will go in the running.
            </p>
          </div>
          <div>
            <img src="/assets/redoctopus.png" />
            <h3>Musican Prize</h3>
            <p>One $1000 Red Octopus gift voucher for printed band/performer merchandise.
            </p>
          </div>
          <div>
            <img src="/assets/lucaffe.png" />
            <h3>Business Prize</h3>
            <p>One Lucaffe Australia pack featuring one Lucaffe Cafe Vintage coffee machine (colour to be chosen by winner), tasting pack of a selection of our delicious ESE coffee pods, stainless steel steaming jug for frothing milk, two Lucaffe Espresso glasses and two Lucaffe Cappucino Cups and saucers.</p>
          </div>
          <div>
            <img src="/assets/as.png" />
            <h3>Business Prize</h3>
            <p>A $500 business accounting voucher for two lucky winners, thanks to AS Accounting.</p>
          </div>
          <div>
            <img src="/assets/hairypants.png" />
            <h3>Pet Prize</h3>
            <p>One Hairypants Photography photo shoot for your pampered pet plus two 8x12 prints and $100 credit towards wall art.</p>
          </div>
          <div>
            <img src="/assets/4zzz-white.png" />
            <h3>Additional Info</h3>
            <p><Link to="/radiothon">Please consult our prize page for full prize information and all our terms and conditions.</Link></p>
          </div>
        </Slider>
      </div>
    )
  }
}

export default MajorPrizes
